<template>
  <div class="scence" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <TownName ref="townlist" v-on:townadcd="townAdcd"></TownName>
      <div class="skt" ref="skt">
        <div class="select">
          <span class="xzqh">站名:</span>
          <div class="selcountry">
            <el-input v-model="query.stnm" clearable placeholder="请输入名称" @change="Global.emptyQuery(query.stnm,searchtown)"></el-input>
          </div>
          <span class="xzqh">站类:</span>
          <div class="selcountry">
            <el-select v-model="query.sttp" placeholder="请选择" filterable clearable @change="Global.emptyQuery(query.sttp,searchtown)">
              <el-option label="雨量站" value="PP"> </el-option>
              <el-option label="水库站" value="RR"> </el-option>
              <el-option label="河道站" value="ZZ"> </el-option>
            </el-select>
          </div>
          <!-- <span class="xzqh">报汛项目:</span>
          <div class="selcountry">
            <el-input v-model="query.stnm" clearable placeholder="请输入名称"></el-input>
          </div> -->
          <!-- <span class="xzqh">报汛等级:</span>
          <div class="selcountry">
            <el-select v-model="query.alarmLevel" placeholder="请选择" filterable clearable>
              <el-option label="中央报汛站" value="中央报汛站"> </el-option>
              <el-option label="省级重点报汛站" value="省级重点报汛站"> </el-option>
              <el-option label="省级一般报汛站" value="省级一般报汛站"> </el-option>
              <el-option label="其它报汛站" value="其它报汛站"> </el-option>
            </el-select>
          </div>
          <span class="xzqh">测站岸别:</span>
          <div class="selcountry">
            <el-select v-model="query.coastType" placeholder="请选择" filterable clearable>
              <el-option label="左岸" value="左岸"> </el-option>
              <el-option label="右岸" value="右岸"> </el-option>
            </el-select>
          </div> -->
          <span class="xzqh">启用状态:</span>
          <div class="selcountry">
            <el-select v-model="query.usfl" placeholder="请选择" filterable clearable @change="Global.emptyQuery(query.usfl,searchtown)">
              <el-option label="是" value="1"> </el-option>
              <el-option label="否" value="0"> </el-option>
            </el-select>
          </div>
          <span class="xzqh">主要站点:</span>
          <div class="selcountry">
            <el-select v-model="query.onlyMain" placeholder="请选择" filterable clearable @change="Global.emptyQuery(query.onlyMain,searchtown)">
              <el-option label="是" :value="true"> </el-option>
              <el-option label="否" :value="false"> </el-option>
            </el-select>
          </div>
          <span id="search" @click="searchtown">查询</span>
          <span v-if="allowsPerm.update" id="export" @click="exportdata"><span class="export-icon"></span>导出</span>
          <span v-if="allowsPerm.delete" id="del" @click="delDialog(multipleSelection)"><span class="del-icon"></span>删除</span>
          <span v-if="allowsPerm.update" id="edit" @click="editDialog"><span class="edit-icon"></span>编辑</span>
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table ref="multipleTable" @row-click="clickRow" v-loading="loading" :data="tdata" :max-height="height" border @selection-change="handleSelectionChange" style="width: 100%; text-align: center;">
              <el-table-column type="selection" width="40" align="center" fixed="left">
              </el-table-column>
              <el-table-column type="index" width="60" label="序号" align="center" fixed="left" :index='(index)=>{return (index+1) + (pageIndex-1)*pageSize }'>
              </el-table-column>
              <el-table-column  prop="stcd" label="终端编码" min-width="140" align="center" fixed="left">
              </el-table-column>
              <el-table-column  prop="stnm" label="终端名称" min-width="140" align="center" fixed="left">
              </el-table-column>
              <el-table-column  prop="stationstcd" label="测站编码" min-width="140" align="center" fixed="left">
              </el-table-column>
              <el-table-column  prop="stationName" label="测站名称" min-width="140" align="center" fixed="left">
              </el-table-column>
              <el-table-column  prop="sttpstr" label="站类" min-width="140" align="center" fixed="left">
              </el-table-column>
              <el-table-column  prop="addvnm" label="乡镇" min-width="140" align="center" fixed="left">
              </el-table-column>
              <el-table-column prop="mainStation"  label="主要站点" min-width="140" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.mainStation?'是':'否'}}</span>
                </template>
              </el-table-column>
              <el-table-column  prop="rvnm" label="河流名称" min-width="140" align="center">
              </el-table-column>
              <el-table-column  prop="hnnm" label="水系名称" min-width="140" align="center">
              </el-table-column>
              <el-table-column  prop="lgtd" label="经度" min-width="140" align="center">
              </el-table-column>
              <el-table-column  prop="lttd" label="纬度" min-width="140" align="center">
              </el-table-column>
              <el-table-column  prop="stlc" label="站址" min-width="140" align="center">
              </el-table-column>
              <el-table-column  prop="dtmnm" label="基面名称" min-width="140" align="center">
              </el-table-column>
              <el-table-column  prop="dtmel" label="基面高程(m)" min-width="140" align="center">
              </el-table-column>
              <el-table-column  prop="dtpr" label="基面修正值(m)" min-width="140" align="center">
              </el-table-column>
              <el-table-column  prop="sttpstr" label="报讯项目" min-width="140" align="center">
              </el-table-column>
              <!-- <el-table-column prop="alarmLevel"  label="报汛等级" min-width="140" align="center">
              </el-table-column> -->
              <el-table-column prop="esstym"  label="建站年月" min-width="140" align="center">
              </el-table-column>
              <el-table-column prop="bgfrym"  label="始报年月" min-width="140" align="center">
              </el-table-column>
               <el-table-column prop="atcunit"  label="隶属行业单位" min-width="140" align="center">
              </el-table-column>
               <!-- <el-table-column prop="stnm"  label="信息管理单位" min-width="140" align="center">
              </el-table-column> -->
              <el-table-column prop="locality"  label="交换管理单位" min-width="140" align="center">
              </el-table-column>
              <!-- <el-table-column prop="coastType"  label="测站岸别" min-width="140" align="center">
              </el-table-column> -->
               <!-- <el-table-column prop="stnm"  label="测站方位(度)" min-width="140" align="center">
              </el-table-column>
               <el-table-column prop="stnm"  label="至河口距离" min-width="140" align="center">
              </el-table-column>
               <el-table-column prop="stnm"  label="集水面积(k㎡)" min-width="140" align="center">
              </el-table-column>
               <el-table-column prop="stnm"  label="拼音码" min-width="140" align="center">
              </el-table-column> -->
              <el-table-column prop="usflstr"  label="启用标志" min-width="140" align="center">
              </el-table-column>
               <!-- <el-table-column prop="stnm"  label="是否含人工" min-width="140" align="center">
              </el-table-column> -->
               <!-- <el-table-column prop=""  label="站点重要等级" min-width="140" align="center">
              </el-table-column>
               <el-table-column prop=""  label="遥测采集数据时间频率" min-width="140" align="center">
              </el-table-column>
               <el-table-column prop=""  label="是否控制站" min-width="140" align="center">
              </el-table-column>
               <el-table-column prop="stnm"  label="站名" min-width="140" align="center">
              </el-table-column>
               <el-table-column prop="sttplist" :formatter="formatztflag" label="测站类型" min-width="120">
              </el-table-column>
              <el-table-column prop="maxWater"  label="历史最高" min-width="90" align="center">
                <template slot-scope="scope">
                  <font v-if="scope.row.maxWater === '' || scope.row.maxWater === undefined">--</font>
                  <font v-else>{{scope.row.maxWater}}</font>
                </template>
              </el-table-column>
              <el-table-column prop="maxTime"  label="历史最高时间" min-width="140" align="center">
              </el-table-column>
              <el-table-column prop="minWater"  label="历史最低" min-width="90" align="center">
                <template slot-scope="scope">
                  <font v-if="scope.row.minWater === '' || scope.row.minWater === undefined">--</font>
                  <font v-else>{{scope.row.minWater}}</font>
                </template>
              </el-table-column>
              <el-table-column prop="minTime"  label="历史最低时间" min-width="140" align="center">
              </el-table-column>
              <el-table-column prop="lgtd"  label="经度" min-width="100" align="center">
              </el-table-column>
              <el-table-column prop="lttd"  label="纬度" min-width="100" align="center">
              </el-table-column>
              <el-table-column prop="enabled" label="是否启用" min-width="80" align="center">
                  <template slot-scope="scope">
                   {{ scope.row.enabled === '0' ? '否' : '是' }}
                </template>
              </el-table-column> -->
              <el-table-column label="操作" min-width="80" align="center" v-if="allowsPerm.update" fixed="right">
                <template slot-scope="scope">
                  <div class="tableBtn flexDiv flexSA">
                    <el-tooltip class="item" effect="dark" content="库(湖)站汛限水位" placement="top" v-if="scope.row.sttp && scope.row.sttp.includes('RR') && scope.row.rrSet">
                      <i class="iconfont iconshuiwei" @click.stop="editsw(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="库(湖)防洪指标" placement="top" v-if="scope.row.sttp && scope.row.sttp.includes('RR') && scope.row.rrSet">
                      <i class="iconfont iconshuiligongchengxinxitongji1" @click.stop="editsl(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="库(湖)库容线" placement="top" v-if="scope.row.sttp && scope.row.sttp.includes('RR') && scope.row.rrSet">
                      <i class="iconfont iconzhibiaoguanli" @click.stop="editkr(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="河道防洪指标" placement="top" v-if="scope.row.sttp && scope.row.sttp.includes('ZZ') && scope.row.zzSet">
                      <i class="iconfont iconshuiwei" @click.stop="editsw(scope.row)"></i>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <pager
          @current-change="onCurrentChange"
          @size-change="onSizeChange"
          :pageIndex="pageIndex"
          :pageSize="pageSize"
          :total="total"
        ></pager>
      </div>
    </div>
    <!-- 新增 -->
    <el-dialog
      class="abow_dialog"
      :title="status + '自动遥测站信息'"
      :visible.sync="addbtn"
      :close-on-click-modal="false"
      >
      <el-form ref="groupForm" :model="form" :rules="rules" label-width="170px" label-height="40px">
        <el-form-item label="终端编码:" prop="stcd" >
          <el-input v-model="form.stcd" disabled></el-input>
        </el-form-item>
        <el-form-item label="终端名称:" prop="stnm">
          <el-input v-model="form.stnm"></el-input>
        </el-form-item>
        <el-form-item label="测站编码:" prop="stationstcd">
          <el-input v-model="form.stationstcd" disabled></el-input>
        </el-form-item>
        <el-form-item label="测站名称:" prop="stationId">
          <el-select v-model="form.stationId" filterable clearable placeholder="请选择测站名称" @change="changeStationStcd">
             <el-option
              v-for="item in stations"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="乡镇:" prop="adcd" clearable>
          <el-select v-model="form.addvcd" filterable clearable placeholder="请选择行政区划">
             <el-option
              v-for="item in adcds"
              :key="item.id"
              :label="item.adnm"
              :value="item.adcd">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经度:" prop="lgtd">
          <el-input v-model="form.lgtd"></el-input>
        </el-form-item>
        <el-form-item label="纬度:" prop="lttd">
          <el-input v-model="form.lttd"></el-input>
          <DrawPoint :globalmapId='globalmapId' :latlng='latlngarr' @changeAdd='handleChangeAdd'></DrawPoint>
        </el-form-item>
        <el-form-item label="基面名称:" prop="dtmnm">
          <el-input v-model="form.dtmnm"></el-input>
        </el-form-item>
        <el-form-item label="基面高程(m):" prop="dtmel">
          <el-input v-model="form.dtmel"></el-input>
        </el-form-item>
        <el-form-item label="基面修正值(m):" prop="dtpr">
          <el-input v-model="form.dtpr"></el-input>
        </el-form-item>
        <el-form-item label="河流名称:" prop="rvnm">
          <el-input v-model="form.rvnm"></el-input>
        </el-form-item>
        <el-form-item label="水系名称:" prop="hnnm">
          <el-input v-model="form.hnnm"></el-input>
        </el-form-item>
        <el-form-item label="站址:" prop="stlc">
          <el-input v-model="form.stlc"></el-input>
        </el-form-item>
        <!-- <el-form-item label="报讯等级:" prop="alarmLevel">
          <el-input v-model="form.alarmLevel"></el-input>
        </el-form-item> -->
         <el-form-item label="建站年月:" prop="esstym">
          <el-input v-model="form.esstym"></el-input>
        </el-form-item>
        <el-form-item label="始报年月:" prop="bgfrym">
          <el-input v-model="form.bgfrym"></el-input>
        </el-form-item>
        <el-form-item label="隶属行业单位:" prop="atcunit">
          <el-input v-model="form.atcunit"></el-input>
        </el-form-item>
        <el-form-item label="交换管理单位:" prop="locality">
          <el-input v-model="form.locality"></el-input>
        </el-form-item>
         <!-- <el-form-item label="测站岸别:" prop="coastType">
          <el-input v-model="form.coastType"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="警戒水位:" v-show="zz">
          <el-input v-model="form.jj"></el-input>
        </el-form-item>
        <el-form-item label="历史最低:">
          <el-input v-model="form.minWater"></el-input>
        </el-form-item>
        <el-form-item label="历史最低时间:" prop="minTime">
          <el-date-picker
            v-model="form.minTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="历史最高:">
          <el-input v-model="form.maxWater"></el-input>
        </el-form-item>
        <el-form-item label="历史最高时间:" prop="maxTime">
          <el-date-picker
            v-model="form.maxTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="测站类型:" prop="sttplist">
          <el-select v-model="form.sttplist" multiple clearable placeholder="请选择测站类型">
            <el-option
              v-for="item in stationtype"
              :key="item.value"
              :label="item.name"
              :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="保证水位:" v-show="zz">
          <el-input v-model="form.bz"></el-input>
        </el-form-item> -->
        <el-form-item label="主要站点:" prop="mainStation">
          <el-radio-group v-model="form.mainStation">
            <el-radio :label="true">是</el-radio>
            <el-radio :label='false'>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否启用:" prop="usfl">
          <el-radio-group v-model="form.usfl">
            <el-radio :label='1'>是</el-radio>
            <el-radio :label='0'>否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addbtn = false">取 消</el-button>
        <el-button type="primary" @click="onGroupSave">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 水位设置 库(湖)站汛限水位-->
    <waterset ref="waterset"></waterset>
    <!-- 水利设置 库(湖)防洪指标 河道防洪指标 -->
    <slSet ref="slSet"></slSet>
    <!-- 库容设置 库(湖)库容线-->
    <krSet ref="krSet"></krSet>
  </div>
</template>
<script>
import scenceTypes from '@/store/types/scence'
import userTypes from '@/store/types/user'
import api from '@/api/scence'
import monitorTypes from '@/store/types/monitor'
import TownName from '@/components/Townname/index.vue'
import { StationType } from '@/utils/enums.js'
import DrawPoint from '@/components/DrawPoint'
import waterset from './waterset'
import slSet from './slSet'
import krSet from './krSet'
import Pager from '@/components/Pager'
export default {
  name: 'Scence',
  components: {
    TownName,
    DrawPoint,
    Pager,
    waterset,
    slSet,
    krSet
  },
  data () {
    return {
      query: {},
      globalmapId: 'baseInfo',
      latlngarr: [],
      stationtype: StationType,
      total: 0,
      sid: '22',
      aDCDVal: '',
      sttp: '',
      stnm: '',
      aDDVCD: '',
      checkarr: [],
      adcdtotal: '',
      all: true,
      choosedate: '',
      radio: '',
      value1: '',
      loading: true,
      height: 10,
      waterForm: {},
      form: { },
      addbtn: false,
      adcdval: [],
      adcds: [],
      stations: [],
      pageIndex: 1,
      pageSize: 20,
      tdata: [],
      isTown: true,
      searchName: '',
      delId: '',
      multipleSelection: [],
      status: '',
      valueId: '',
      aDCD: '330324',
      mutiRanksAdcd: [],
      rr: false,
      zz: false,
      rules: {
        adcdid: [
          { required: true, message: '请选择行政区划', trigger: 'change' }
        ],
        stnm: [
          { required: true, message: '测站名称不能为空', trigger: 'blur' }
        ],
        sttplist: [
          { required: true, message: '测站类型不能为空', trigger: 'blur' }
        ],
        lng: [
          { validator: this.Global.checkNumeral }
        ],
        lat: [
          { validator: this.Global.checkNumeral }
        ],
        enable: [
          { required: true, message: '请选择是否启用', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    'form.sttplist': {
      handler (newName, oldName) {
        if (newName.indexOf('ZZ') !== -1) {
          this.zz = true
        } else {
          this.zz = false
        }
        if (newName.indexOf('RR') !== -1) {
          this.rr = true
        } else {
          this.rr = false
        }
      },
      deep: true
    }
  },
  methods: {
    editsw (row) {
      this.$refs.waterset.editWaterDialog(row)
    },
    editsl (row) {
      this.$refs.slSet.editDialog(row)
    },
    editkr (row) {
      this.$refs.krSet.onEdit(row)
    },
    onSizeChange (pageSize) {
      this.pageIndex = 1
      this.pageSize = pageSize
      this.thedata()
    },
    onCurrentChange (pageIndex) {
      this.pageIndex = pageIndex
      this.thedata()
    },
    handleChangeAdd (data) {
      this.form.lgtd = data.lng
      this.form.lttd = data.lat
    },
    // 行政区划选择
    townAdcd: function (townAdcd) {
      this.loading = true
      this.pageIndex = 1 // 查询重置页码
      this.query.addvcd = townAdcd
      this.thedata()
    },
    formatztflag (row, column) {
      let showstr = ''
      if (row.sttplist && row.sttplist.length > 0) {
        row.sttplist.forEach(item => {
          switch (item) {
            case 'DD':
              item = '堰闸水文站'
              break
            case 'TT':
              item = '潮位站'
              break
            case 'PP':
              item = '雨量站'
              break
            case 'ZZ':
              item = '河道站'
              break
            case 'RR':
              item = '水库站'
              break
            default:
              break
          }
          showstr += item + ','
        })
        return showstr.slice(0, showstr.length - 1)
      }
    },
    thedata () {
      this.loading = true
      this.query.pageIndex = this.pageIndex
      this.query.pageSize = this.pageSize
      let promise1 = api.getstationBaseList(this.query)
      let promise2 = this.$store.dispatch(userTypes.GET_RIVER_LIST_INFO, {
        sid: 22,
        pageIndex: 1,
        pageSize: 500,
        sttp: 'ZZ'
      })
      let promise3 = this.$store.dispatch(monitorTypes.GET_STATISTICS_RESERVOIR_WATER, {
        sID: 22
      })
      Promise.all([promise1, promise2, promise3]).then(resArr => {
        let res = resArr[0]
        let arr = res.data.rows
        arr.forEach(item => {
          item.sttplist = item.sttpgroup
          if (resArr[1].rows.find(el => { return item.stationId === el.stationId })) {
            item.zzSet = true
          }
          if (resArr[2].rows.find(el => { return item.stcD8 === el.stcD8 })) {
            item.rrSet = true
          }
        })
        this.tdata = arr
        this.total = res.data.total
        this.loading = false
      })
    },
    adcddata () {
      this.$store.dispatch(monitorTypes.GET_ADCD, {
        isTown: this.isTown,
        searchName: this.searchName,
        pageIndex: 1,
        pageSize: 1000
      }).then(data => {
        this.adcdtotal = data.results.length
        this.adcds = data.results
      })
    },
    stationdata () {
      this.$store.dispatch(scenceTypes.GET_SITE_ALL).then(data => {
        this.stations = data.rows
      })
    },
    searchtown () {
      this.pageIndex = 1 // 查询重置页码
      // this.setAllCheck()
      this.thedata()
    },
    handleSelectionChange (val) {
      // 清理赋值
      this.multipleSelection = JSON.parse(JSON.stringify(val))
    },
    // 新增
    addDialog () {
      this.status = '新增'
      this.zz = false
      this.rr = false
      this.form = {
        enable: true
      }
      this.addbtn = true
      this.Global.clearValidate(this, 'groupForm')
    },
    // 水位设置
    editWaterDialog () {
      if (this.multipleSelection.length < 1) {
        this.$alert('需要选择一条数据才可进行该操作！请选择其中一条数据。', '提示')
      } else if (this.multipleSelection.length > 1) {
        this.$alert('该操作不可对多条数据同时进行操作。', '提示')
      } else {
        let row = this.multipleSelection[0]
        this.$refs.waterset.editWaterDialog(row)
      }
    },
    // 编辑
    editDialog () {
      this.latlngarr = []
      this.status = '编辑'
      this.zz = false
      this.rr = false
      if (this.multipleSelection.length < 1) {
        this.$alert('需要选择一条数据才可进行该操作！请选择其中一条数据。', '提示')
      } else if (this.multipleSelection.length > 1) {
        this.$alert('该操作不可对多条数据同时进行操作。', '提示')
      } else {
        this.addbtn = true
        this.form = Object.assign({}, this.multipleSelection[0])
        this.form.usfl = Number(this.form.usfl)
        this.latlngarr.push(this.form.lgtd, this.form.lttd)
        this.Global.clearValidate(this, 'groupForm')
      }
    },
    // 删除
    delDialog (rows) {
      if (rows < 1) {
        this.$alert('请先勾选需要删除的数据项！', '提示')
      } else {
        this.delId = [] // 清空数组
        rows.forEach(item => {
          this.delId.push(item.id)
        })
        this.$confirm(`确定要删除已选择的自动遥测站数据 ?`, '确认').then(() => {
          this.loading = true
          this.$store.dispatch(scenceTypes.DELETE_STATIONINFO, { id: this.delId.join(',') }).then(() => {
            this.loading = false
            this.$notify.success({ title: '成功', message: '删除数据成功.' })
            this.thedata()
          }).catch(() => { this.loading = false })
        }).catch(() => {})
      }
    },
    // 保存新增/编辑
    onGroupSave () {
      if (this.form.sttplist.length > 0) {
        this.form.sttp = this.form.sttplist.join(',')
      } else {
        this.form.sttp = ''
      }
      if (this.form.addvcd) {
        this.$refs['groupForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            this.$store.dispatch(scenceTypes.SAVE_STATIONINFO, this.form).then((res) => {
              if (res.result === 'SUCCESS') {
                this.loading = false
                this.addbtn = false
                this.$notify.success({ title: '成功', message: '保存成功。' })
                this.thedata()
                this.form = {}
              } else {
                this.$notify.error({ title: '失败', message: res.msg })
                this.loading = false
              }
            }).catch(() => {
              this.$notify.error({ title: '失败', message: '保存失败.' })
              this.loading = false
            })
          }
        })
      }
    },
    exportdata() {
      let obj = {
        addvcd: this.query.addvcd,
        hasRain: this.query.hasRain,
        hasWater: this.query.hasWater,
        onlyMain: this.query.onlyMain,
        pageIndex: 1,
        pageSize: 500,
        stnm: this.query.stnm,
        sttp: this.query.sttp,
        usfl: this.query.usfl
      }
      this.loading = true
      this.$store.dispatch(scenceTypes.EXPORT_STATIONINFO, obj).then((data) => {
        window.location.href = this.Global.basePath + data.data
        this.loading = false
        // this.$notify.success({ title: '成功', message: '导出成功。' })
      }).catch(() => {
        this.$notify.error({ title: '失败', message: '导出失败.' })
        this.loading = false
      })
    },
    //  行选中
    clickRow (row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    // 测站编码与测站联动
    changeStationStcd(item) {
      let stationObj = this.stations.filter(el => {
        return el.id === item
      })
      this.form.stationstcd = stationObj[0].stationstcd
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
  },
  mounted () {
    // var _this = this
    // window.onresize = function () { // 定义窗口大小变更通知事件
    //   location.reload()
    //   _this.screenHeight = document.documentElement.clientHeight // 窗口高度
    // }
    this.thedata()
    this.adcddata()
    this.stationdata()
    this.$nextTick(() => {
      let sktDiv = document.getElementsByClassName('skt')
      this.height = sktDiv[0].offsetHeight - 120
    })
  }
}
</script>
<style lang="less" src="@/assets/scene.less" scoped>
</style>
<style scoped>
.scence .skt{
  height: calc(100% - 77px);
}
.countryList{
  height: 62px !important;
  background-color: #ffffff;
  border-radius: 5px;
  color: #444444;
  font-size: 15px;
}
.country{
  float: left;
  font-family: Microsoft YaHei UI;
  font-size: 15px;
  text-align: center;
  margin-top: 20px;
  margin-left: 0.5%;
  cursor: pointer;
}
.countryon{
  border-radius: 15px;
  background-color: #fda72c;
  color: #ffffff
}
.country span{
  padding: 4px 15px;
}
.scence >>> .el-dialog__body {
  height: 70%;
  left: 0;
  top: 54px;
  bottom: 0;
  right: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}
.scence >>> .el-dialog {
  margin: 0 auto !important;
}
.scence >>> .el-form-item{
  margin-left: 1%;
  width: 44% !important;
}
.scence >>> .el-dialog__footer {
  margin-top: -30px;
}
.scence .abow_dialog >>> .el-input{
  width: 190px !important;
}
.scence >>>.tableBtn i{
  font-size: 18px;
  cursor: pointer;
}
.scence >>>.tableBtn i:hover{
  color: rgb(125, 166, 233)
}
.flexDiv {
  display: flex;
  align-items: center;
}
.flexSB {
  justify-content: space-between;
}
.flexSA {
  justify-content: space-around;
}
</style>
